import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Profile from '../pages/Auth/profile'
import Dashboard from "../pages/Dashboard/dashboard";
import Batches from "../pages/Batches/batches";
import CoachMgmt from "../pages/coach-mgmt/coach-mgmt";
// import courses from "../pages/courses/courses";
import KidsMgmt from "../pages/kids-mgmt/kids-mgmt";
import PointsSetUp from "../pages/points/PointsSetUp";
import Notifications from "../pages/notifications/notifications";
// import AddCourse from "./addNewCourse/addCourse";
import EventsAndChallenges from "../pages/events-and-challenges/EventsAndChallenges";
import ContentMgmt from "../pages/content-mgmt/content-management";
import { useSelector } from "react-redux";
import StudMgmt from "../pages/student-mgmt/StudentManagement";
import { DefaultReduxState } from "../store";
import Courses from "../pages/courses/courses";
import ManageAdmins from "../pages/Auth/manageAdmins";
import ActivityLogsPage from "../pages/ActivityLogs";


const AppRoutes = () => {
  const auth = useSelector((state: DefaultReduxState) => state.auth);

  return (
    <Routes>
      {auth?.isSuper ? (
        <>
          {/* Superadmin routes */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/manage-admins" element={<ManageAdmins />} />
          <Route path="/batch" element={<Batches />} />
          <Route path="/course-set-up" element={<Courses />} />
          <Route path="/workshops" element={<EventsAndChallenges />} />
          <Route path="/points-set-up" element={<PointsSetUp />} />
          <Route path="/coach-management" element={<CoachMgmt />} />
          <Route path="/student-mgmt" element={<KidsMgmt />} />
          <Route path="/batch-mgmt" element={<StudMgmt />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/content-mgmt" element={<ContentMgmt />} />
          <Route path="/activity-logs" element={<ActivityLogsPage />} />
        </>
      ) : auth?.isCoach ? (
        <>
          <Route path="/" element={<Navigate to={"/batch-mgmt"} />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/batch-mgmt" element={<StudMgmt />} />
          <Route path="/notifications" element={<Notifications />} />
        </>
      ) : auth?.isContentAdmin ? (
        <>
          <Route path="/" element={<Navigate to={"/points-set-up"} />} />
          <Route path="/points-set-up" element={<PointsSetUp />} />
          <Route path="/workshops" element={<EventsAndChallenges />} />
          <Route path="/content-mgmt" element={<ContentMgmt />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/manage-admins" element={<ManageAdmins />} />
          <Route path="/batch" element={<Batches />} />
          <Route path="/course-set-up" element={<Courses />} />
          <Route path="/workshops" element={<EventsAndChallenges />} />
          <Route path="/points-set-up" element={<PointsSetUp />} />
          <Route path="/coach-management" element={<CoachMgmt />} />
          <Route path="/student-mgmt" element={<KidsMgmt />} />
          <Route path="/batch-mgmt" element={<StudMgmt />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/content-mgmt" element={<ContentMgmt />} />
          <Route path="/activity-logs" element={<ActivityLogsPage />} />
        </>
      )
      }

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;